import React, { useMemo, useRef } from "react";

import { isNonEmptyArray, isEmpty } from "_helpers";

import { CardCustom as Card } from "./_Card";
import { CollapseHeaderCustom as CollapseHeader } from "./_CollapseHeader";

import { Collapse } from "antd";
import { isEmptyObject } from "jquery";

export function BasesStatus({ fetchData }){
    const defaultActiveKey = useRef(["veo", "veowhite"]).current;

    const data = useMemo(() => {
        if( isEmpty(fetchData) ) return {};

        const dataReduced = Object.entries(fetchData).reduce((acc, [key, val]) => {
            const keySplit = key.split("@"); 
            let domain = keySplit[1];
            const subDomain = keySplit[0];

            if( !acc[domain] ){
                acc[domain] = [];
            } 

            if( domain !== "veo" && domain !== "veowhite" && !acc["other"] ){
                acc["other"] = [];
            }

            switch(domain){
                case "veo" :
                case "veowhite" :
                    acc[domain].push({title: subDomain, ...val});
                    break;
                default : 
                    acc["other"].push({title: subDomain, ...val});
                    break;
            }
            
            return acc;
        }, {});

        return Object.fromEntries(Object.entries(dataReduced).filter(([_,val]) => isNonEmptyArray(val)));
    }, [fetchData]);

    const collapseItems = useMemo(() => {
        if( isEmptyObject(data) ) return [];
        return Object.entries(data).map(([key, val]) => {
            return {
                key,
                label: <CollapseHeader entries={{ key, val }} />,
                children: <Card entry={{ val }} />
            }
        })
    }, [data]);

    return (
        <div>
            <Collapse 
                items={collapseItems} 
                ghost 
                expandIcon={() => null}    
                defaultActiveKey={defaultActiveKey}
            />
        </div>
    );
}